import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except 408, 429
        if (error instanceof Error && 'status' in error) {
          const status = (error as any).status
          if (status >= 400 && status < 500 && status !== 408 && status !== 429) {
            return false
          }
        }
        // Retry up to 3 times for other errors
        return failureCount < 3
      },
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
    },
  },
})

// Query keys for better organization and type safety
export const queryKeys = {
  // Auth queries
  auth: ['auth'] as const,
  user: ['user'] as const,
  login: (username: string) => ['auth', 'login', username] as const,
  
  // Notification queries
  notifications: ['notifications'] as const,
  notificationsByUser: (userId: number) => ['notifications', userId] as const,
  unreadCount: (userId: number) => ['notifications', userId, 'unread'] as const,
  
  // Other queries (we'll add these later)
  users: ['users'] as const,
  centers: ['centers'] as const,
  branches: ['branches'] as const,
  fees: ['fees'] as const,
  transfers: ['transfers'] as const,
} as const

export type QueryKeys = typeof queryKeys
